import { assertAcceptedResult, validateOrder } from '../api/validateOrder.js';
import { sendOrder } from '../contracts/sendOrder.js';
import { waitForOrderClose, } from '../contracts/waitForOrderClose.js';
import { waitForOrderOpen } from '../contracts/waitForOrderOpen.js';
export async function* generateOrder(params) {
    const { environment, pollingInterval, ...sendOrderParams } = params;
    const validationResult = await validateOrder({
        ...params.order,
        environment,
    });
    assertAcceptedResult(validationResult);
    yield { status: 'valid' };
    const txHash = await sendOrder(sendOrderParams);
    yield { status: 'sent', txHash };
    const order = await waitForOrderOpen({
        client: params.client,
        txHash,
        pollingInterval,
    });
    yield { status: 'open', txHash, order };
    const status = await waitForOrderClose({
        client: params.client,
        inboxAddress: params.inboxAddress,
        orderId: order.orderId,
        pollingInterval,
    });
    yield { status, txHash, order };
}
//# sourceMappingURL=generateOrder.js.map